import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img src="/LandingPageAssets/Images/Common/Karen.webp" alt="Karen Imbaquingo - Agente Inmobiliaria en Quito y Los Valles | J&K Realty" width="960" height="1280" loading="lazy" decoding="async" />
            <div className="experience-badge">
              <span className="years">7+</span>
              <span className="label">Años de Excelencia</span>
            </div>
          </div>
          <div className="about-text">
            <span className="section-label">Conóceme</span>
            <h2 className="section-title">
              Hola, Soy Karen Imbaquingo
            </h2>
            <p className="about-description">
              Con más de 7 años de experiencia en el mercado inmobiliario de Quito y los Valles, desarrollando una gestión comercial integral orientada a resultados reales y sostenibles.
            </p>
            <p className="about-description">Mi trabajo abarca cada etapa del proceso de compra y venta de propiedades:</p>
            <div className="about-highlights">
              <div className="highlight">
                <i className="icon-check"></i>
                <span>Análisis y estrategia comercial del inmueble</span>
              </div>
              <div className="highlight">
                <i className="icon-check"></i>
                <span>Avalúo técnico y estudio comparativo de mercado</span>
              </div>
              <div className="highlight">
                <i className="icon-check"></i>
                <span>Plan de posicionamiento y negociación profesional</span>
              </div>
              <div className="highlight">
                <i className="icon-check"></i>
                <span>Acompañamiento en pago de impuestos y obligaciones municipales</span>
              </div>
              <div className="highlight">
                <i className="icon-check"></i>
                <span>Gestión de trámites notariales y asesoramiento legal inmobiliario</span>
              </div>
              <div className="highlight">
                <i className="icon-check"></i>
                <span>Coordinación integral hasta el cierre exitoso</span>
              </div>
            </div>
            <p className="about-description">
              Entiendo que una propiedad no es solo un bien, es patrimonio, inversión y estilo de vida. Por eso ofrezco un trato personalizado, confidencial y estratégico, adaptado a los objetivos y tiempos de cada cliente.
            </p>
            <p className="about-description">
              Brindo asesoría clara, estructurada y moderna, donde cada decisión está respaldada por análisis, experiencia y criterio profesional.
            </p>
            <p className="about-description"><em>Invertir, vender y adquirir con visión. Vivir con elegancia.</em></p>
            <div className="about-cta">
              <a href="https://wa.me/593995410584" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Agendar Consulta</a>
              <div className="contact-quick">
                <span>Llámame directamente: <a href="tel:+593995410584" className="phone">+593 99 541 0584</a></span>
                <span>O sígueme: <a href="https://www.instagram.com/jk_realty_uio/" target="_blank" rel="noopener noreferrer" className="instagram-link">@jk_realty_uio</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
